import ContentManagmentApi from '@/services/api/contentManagmentApi.js'
import { mapGetters } from 'vuex'

const ContentManagmentApiService = new ContentManagmentApi()

export const homePageHelper = {
  data: function () {
    return {
      perfectForTheTitle: 'PERFECT FOR THE'
    }
  },
  computed: {
    ...mapGetters({
      retailer: 'retailerState',
      user: 'userState'
    })
  },
  methods: {
    getPerfectForTheTrackEventData: function ({ title, homepage_title }) {
      return {
        action: 'Perfect For The Collections Click',
        properties: {
          Location: 'Homepage',
          'Collection Name': title || homepage_title,
          'Retailer Store Name': this.retailer ? this.retailer.store_name : ' - ',
          'Retailer email': this.retailer ? this.retailer.email : ' - '
        }
      }
    },
    fetchMapCollectionsToCarouselItems: async function () {
      try {
        const { data } = await ContentManagmentApiService.getCollectionsCarousel(false)
        const { view_components, name } = data
        if (name) {
          this.perfectForTheTitle = name
        }

        return view_components?.map(({ entity_id, image_url, title, homepage_title }) => {
          return {
            title: title || homepage_title,
            imageUrl: image_url,
            id: entity_id,
            routerLinkTo: {
              name: 'Collection',
              params: {
                collectionId: entity_id,
                collectionName: title || homepage_title
              }
            },
            trackEventData: {
              action: 'Perfect For The Collections Click',
              properties: {
                Location: 'Homepage',
                'Collection Name': title || homepage_title,
                'Retailer Store Name': this.retailer ? this.retailer.store_name : ' - ',
                'Retailer email': this.retailer ? this.retailer.email : ' - '
              }
            }
          }
        })
      } catch (error) {
        return []
      }
    }
  }
}
